import React, { useEffect, useState } from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const Medicos = (props) => {
  document.title = "Clientes | Dashboard Olis";

  const [clientes, setClientes] = useState([]);
  const [data, setData] = useState({
    columns: [
      { label: "Nome", field: "nome", sort: "asc", width: 150 },
      { label: "Email", field: "email", sort: "asc", width: 150 },
      { label: "CPF", field: "cpf", sort: "asc", width: 150 },
      { label: "Telefone", field: "telefone", sort: "asc", width: 150 },
      { label: "Ações", field: "acoes", sort: "asc", width: 100 },
    ],
    rows: [],
  });
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    getClientes(page, search);
  }, [page, search]);

  const getClientes = (page, search) => {
    fetch(
      `${process.env.REACT_APP_API}/clientes?page=${page}&limit=10&nome=${search}`
    )
      .then((response) => response.json())
      .then((response) => {
        setClientes(response.data);
        setTotalPages(response.pagination.totalPages);

        setData((prevState) => ({
          ...prevState,
          rows: response.data.map((cliente) => ({
            nome: cliente.nome,
            email: cliente.email,
            cpf: cliente.cpf,
            telefone: cliente.telefone,
            acoes: (
              <Button
                color="primary"
                size="sm"
                tag={Link}
                to={`/perfil-cliente/${cliente.id_cliente}`}
              >
                Ver Perfil
              </Button>
            ),
          })),
        }));
      })
      .catch((error) => console.error("Erro ao buscar clientes:", error));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col md={6}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar por nome"
                    value={search}
                    onChange={handleSearchChange}
                  />
                </Col>
              </Row>
              {clientes.length > 0 && (
                <MDBDataTable striped responsive bordered data={data} />
              )}
              <div className="d-flex justify-content-between">
                <Button
                  color="primary"
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page <= 1}
                >
                  Anterior
                </Button>
                <span>
                  Página {page} de {totalPages}
                </span>
                <Button
                  color="primary"
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page >= totalPages}
                >
                  Próxima
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, {})(Medicos);
